<template>
  <div>
    <div class="dpl_page_title">
      <h1 style="display: inline-block">Inventories</h1>
    </div>
    <div class="dpl_alert_wrapper">
      <div class="alert alert-info alert-large">
        <p>
          The inventory in the Etsy products listed below will sync from Shopify
          based on the matching SKU.
        </p>
      </div>
    </div>
    <div class="dpl_card">
      <div class="dpl_table_container">
        <div
          id="feedproductlist_wrapper"
          class="dataTables_wrapper no-footer"
          style="width: 100%; padding: 0"
        >
          <div class="dpl_row dpl_mB-3 dpl_table_filter dpl_mT-0">
            <div class="dpl_col_xl-8 dpl_col-12">
              <div class="dpl_row dpl_gx-2 dpl_gy-2">
                <div class="dpl_col-12 dpl_col_lg-5 dpl_col_md-6">
                  <div class="dpl_form_search_wrapper">
                    <input
                      type="search"
                      class="dpl_search_input"
                      v-model="search_keyword"
                      placeholder="Search Product by Product SKU or Title"
                      aria-controls="orders_table"
                    />
                  </div>
                </div>
                <div class="dpl_col-12 dpl_col_lg-3 dpl_col_md-3 dpl_col_sm-4">
                  <button
                    class="dpl_btn dpl_btn_light"
                    id="clear-buttons"
                    type="submit"
                    name="feeds-clear-button"
                    @click="searchData"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
            <div class="dpl_col_xl-4 dpl_col-12">
              <div class="dpl_row dpl_gx-2" style="float: right">
                <div
                  class="
                    dpl_col-12 dpl_col_xs-8 dpl_col_sm-auto dpl_col_md-auto
                  "
                >
                  <div
                    class="dataTables_paginate paging_simple"
                    id="orders_table_paginate"
                  >
                    <a
                      class="paginate_button previous"
                      :class="{ disabled: pagination.current_page <= 1 }"
                      aria-controls="orders_table"
                      data-dt-idx="0"
                      tabindex="0"
                      id="orders_table_previous"
                      @click="doPaginate('prev')"
                    >
                      <span class="dpl_table_pagination--prev"></span> </a
                    ><span class="cdatatableDetails"
                      >Page {{ pagination.current_page }} of
                      {{ pagination.total_pages }}</span
                    ><a
                      class="paginate_button next"
                      aria-controls="orders_table"
                      data-dt-idx="1"
                      tabindex="0"
                      id="orders_table_next"
                      @click="doPaginate('next')"
                    >
                      <span class="dpl_table_pagination--next"></span
                    ></a>
                  </div>
                </div>
                <div
                  class="
                    dpl_col-12 dpl_col_xs-4 dpl_col_sm-auto dpl_col_md-auto
                  "
                >
                  <div class="dpl_filter_select dpl_pagination_select">
                    <select
                      v-model="pagination.per_page"
                      @change="perPageChange"
                    >
                      <option
                        v-for="value in [5, 10, 15, 20]"
                        :key="`pagination-${value}`"
                        :value="value"
                      >
                        {{ value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <table
            class="table dataTables_table dpl_table dpl_mB-0"
            id="orders_table"
            cellpadding="0"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">SKU</th>
                <th scope="col">Stock</th>
                <th scope="col">Etsy</th>
                <th scope="col">Shopify</th>
                <!-- <th scope="col">Actions</th>{"success":true,"error":"","http_response_code":200,"response":{"count":4,"results":{"products":[{"product_id":5118680986,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["50x100cm"],"value_ids":[163479409338]}],"offerings":[{"offering_id":4978979673,"price":{"amount":139900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,399.00","currency_formatted_long":"$1,399.00 USD","currency_formatted_raw":"1,399.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680988,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["60x100cm"],"value_ids":[166823299741]}],"offerings":[{"offering_id":4978979675,"price":{"amount":149900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,499.00","currency_formatted_long":"$1,499.00 USD","currency_formatted_raw":"1,499.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680990,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["80x100cm"],"value_ids":[188535588799]}],"offerings":[{"offering_id":5091482014,"price":{"amount":179900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,799.00","currency_formatted_long":"$1,799.00 USD","currency_formatted_raw":"1,799.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680992,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["100x100cm"],"value_ids":[196280018436]}],"offerings":[{"offering_id":4978979677,"price":{"amount":189900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,899.00","currency_formatted_long":"$1,899.00 USD","currency_formatted_raw":"1,899.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680994,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["120x100cm"],"value_ids":[727834435045]}],"offerings":[{"offering_id":4978979679,"price":{"amount":219900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$2,199.00","currency_formatted_long":"$2,199.00 USD","currency_formatted_raw":"2,199.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":4872598619,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["150x100cm"],"value_ids":[211140766020]}],"offerings":[{"offering_id":4978979681,"price":{"amount":239900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$2,399.00","currency_formatted_long":"$2,399.00 USD","currency_formatted_raw":"2,399.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":9573821992,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["120x150"],"value_ids":[1042754452396]}],"offerings":[{"offering_id":9572202432,"price":{"amount":279900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$2,799.00","currency_formatted_long":"$2,799.00 USD","currency_formatted_raw":"2,799.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":9573821996,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["150x150"],"value_ids":[301430817443]}],"offerings":[{"offering_id":9394663635,"price":{"amount":339900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$3,399.00","currency_formatted_long":"$3,399.00 USD","currency_formatted_raw":"3,399.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0}],"price_on_property":[513],"quantity_on_property":[],"sku_on_property":[]},"params":{"listing_id":"862992211","write_missing_inventory":false},"type":"ListingInventory","pagination":{}}}{"success":true,"error":"","http_response_code":200,"response":{"count":4,"results":{"products":[{"product_id":5118680986,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["50x100cm"],"value_ids":[163479409338]}],"offerings":[{"offering_id":4978979673,"price":{"amount":139900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,399.00","currency_formatted_long":"$1,399.00 USD","currency_formatted_raw":"1,399.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680988,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["60x100cm"],"value_ids":[166823299741]}],"offerings":[{"offering_id":4978979675,"price":{"amount":149900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,499.00","currency_formatted_long":"$1,499.00 USD","currency_formatted_raw":"1,499.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680990,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["80x100cm"],"value_ids":[188535588799]}],"offerings":[{"offering_id":5091482014,"price":{"amount":179900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,799.00","currency_formatted_long":"$1,799.00 USD","currency_formatted_raw":"1,799.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680992,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["100x100cm"],"value_ids":[196280018436]}],"offerings":[{"offering_id":4978979677,"price":{"amount":189900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$1,899.00","currency_formatted_long":"$1,899.00 USD","currency_formatted_raw":"1,899.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":5118680994,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["120x100cm"],"value_ids":[727834435045]}],"offerings":[{"offering_id":4978979679,"price":{"amount":219900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$2,199.00","currency_formatted_long":"$2,199.00 USD","currency_formatted_raw":"2,199.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":4872598619,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["150x100cm"],"value_ids":[211140766020]}],"offerings":[{"offering_id":4978979681,"price":{"amount":239900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$2,399.00","currency_formatted_long":"$2,399.00 USD","currency_formatted_raw":"2,399.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":9573821992,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["120x150"],"value_ids":[1042754452396]}],"offerings":[{"offering_id":9572202432,"price":{"amount":279900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$2,799.00","currency_formatted_long":"$2,799.00 USD","currency_formatted_raw":"2,799.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0},{"product_id":9573821996,"sku":"FLOWERSHAPETABLE","property_values":[{"property_id":513,"property_name":"Width x Length","scale_id":null,"scale_name":null,"values":["150x150"],"value_ids":[301430817443]}],"offerings":[{"offering_id":9394663635,"price":{"amount":339900,"divisor":100,"currency_code":"USD","currency_formatted_short":"$3,399.00","currency_formatted_long":"$3,399.00 USD","currency_formatted_raw":"3,399.00"},"quantity":17,"is_enabled":1,"is_deleted":0}],"is_deleted":0}],"price_on_property":[513],"quantity_on_property":[],"sku_on_property":[]},"params":{"listing_id":"862992211","write_missing_inventory":false},"type":"ListingInventory","pagination":{}}} -->
              </tr>
            </thead>
            <tbody v-if="!loading_products">
              <div v-frag v-if="productData.data && productData.data.length">
                <etsy-product-row
                  :on-row-expand="toggleVariationns"
                  v-for="etsyProduct in productData.data"
                  :product-detail="etsyProduct"
                  :shop-details="shop"
                  :key="`product-${etsyProduct.id}`"
                />
              </div>
              <div v-frag v-else>
                <tr v-if="is_server_error">
                  <td colspan="6" data-title="Title">
                    <div class="dpl_container">
                      <div
                        class="dpl_row dpl_row_align_itemCenter"
                        style="justify-content: center; padding: 50px 0px"
                      >
                        <div class="dpl_col_sm-4">
                          <h3>Whoops! Something went wrong.</h3>
                          <p style="font-size: 14px; line-height: 1.6">
                            Something went wrong while fetching your inventory
                            data.
                          </p>
                          <button
                            @click="reloadPage"
                            class="
                              dpl_mT-2 dpl_btn dpl_btn_xs dpl_btn_theme
                              sync-etsy-product-details
                            "
                            >Reload the page</button
                          >
                        </div>
                        <div class="dpl_col_sm-3">
                          <img
                            src="/templates/rapidcart/images/server-error.png"
                            alt=""
                            width="300"
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-else>
                  <td colspan="6" data-title="Title">
                    <div class="dpl_container">
                      <div
                        class="dpl_row dpl_row_align_itemCenter"
                        style="justify-content: center; padding: 50px 0px"
                      >
                        <div class="dpl_col_sm-4">
                          <h3>No inventory data found!</h3>
                          <p style="font-size: 15px; line-height: 1.6">
                            It seems we haven't fetched your inventory data from
                            Etsy yet.
                          </p>
                          <button
                            @click="fetchEtsyProducts"
                            :disabled="fetching_etsy_inventory"
                            class="
                              dpl_mT-2 dpl_btn dpl_btn_xs dpl_btn_theme
                              sync-etsy-product-details
                            "
                          >
                            {{ fetching_etsy_inventory ? "Fetching Etsy Products..." : "Fetch Etsy Products" }}
                          </button>
                        </div>
                        <div class="dpl_col_sm-3">
                          <img
                            src="/templates/rapidcart/images/no-data.png"
                            alt=""
                            width="250"
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </div>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="9" data-title="Title">
                  <div class="text-center" style="padding: 80px 0px">
                    <img
                      src="/templates/rapidcart/images/svg/loader.svg"
                      alt=""
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import EtsyProductRow from "./partials/EtsyProductRow.vue";
export default {
  props: {
    // shopId: {
    //   type: Number,
    //   default: 0,
    // },
    // shopDetails: {
    //   type: Object,
    // },
  },
  components: {
    EtsyProductRow,
  },

  data() {
    return {
      shop: null,
      loading_products: true,
      productData: {},
      search_keyword: "",
      pagination: {
        current_page: 1,
        start: 0,
        per_page: 10,
        total_pages: 0,
      },
      is_server_error: false,
      fetching_etsy_inventory: false
    };
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetchInventoryData();
  },
  methods: {
    async fetchInventoryData() {
      try {
        this.loading_products = true;
        let url_params = {
          shop_id: this.shopId,
          per_page: this.pagination.per_page,
          page: this.pagination.current_page,
          search_keyword: this.search_keyword,
        };

        let response = await axios.get(
          `admin/shops/${this.shop.id}/get-inventory-data`,
          {
            params: url_params,
          }
        );

        if (response.data.success) {
          this.productData = response.data.data;
          this.pagination.total_pages = response.data.data.last_page;
        }
      } catch (e) {
        this.is_server_error = true;
      } finally {
        this.loading_products = false;
      }
    },

    toggleVariationns(listing_id, should_show_current_row) {
      this.productData.data.forEach((etsy_product) => {
        if (etsy_product.listing_id == listing_id) {
          this.$set(etsy_product, "expand_variants", should_show_current_row);
        } else {
          this.$set(etsy_product, "expand_variants", false);
        }
      });
    },

    doPaginate(direction) {
      if (direction === "prev") {
        if (this.pagination.current_page <= 1) return;
        this.pagination.current_page--;
      } else {
        if (this.pagination.current_page >= this.pagination.total_pages) return;
        this.pagination.current_page++;
      }

      this.fetchInventoryData();
    },
    searchData() {
      this.pagination.current_page = 1;
      this.fetchInventoryData();
    },

    perPageChange() {
      this.pagination.current_page = 1;
      this.fetchInventoryData();
    },

    async fetchEtsyProducts() {
      this.fetching_etsy_inventory = true;
      try {
        await axios.get(window.BACKEND_SERVICE_HOST + "/api/set-reverse-sync-queue", {
          params: {
            shop_id: this.shopId,
          }
        });
      } catch(e) {

      }
    },

    reloadPage() {
      window.location.reload();
    }
  },
};
</script>

<style scoped>
  @import './../../../styles/revamp/revamp.css';
</style>>
